// Central site config: links, brand, and all editable content data.

export const LINKS = {
  upiId: "7903304884@ptsbi",
  upiName: "Ratish Jha",
  whatsapp:
    "https://wa.me/917903304884?text=Hi%2C%20Ratish%20Ji%2C%20I%20want%20to%20join%20the%20YouTube%20Lead%20Generation%20Course.",
  youtube: "#",
  website: "#",
};

export const PRICING = {
  reference: "49,999",
  current: "29,999",
  monthly: "2,500",
  seats: 30,
  seatsRemaining: 11, // editable placeholder
};

export const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_fe3d7dd2-4380-43cf-8a5b-05692be5d15a/artifacts/e0mkrqw1_ChatGPTImageJul11202612_35_22A.jpeg";

export const IMAGES = {
  proofEarnings: "https://customer-assets.emergentagent.com/job_expertise-to-leads/artifacts/clolsquw_2026-07-11%2016_49_43-Epic%20Pen%20Content%20Surface_%20__._DISPLAY1.png",
  proofAffiliate: "https://customer-assets.emergentagent.com/job_expertise-to-leads/artifacts/jvthqoc4_2026-07-11%2016_47_42-Epic%20Pen%20Content%20Surface_%20__._DISPLAY1.png",
  proofRanking: "https://customer-assets.emergentagent.com/job_expertise-to-leads/artifacts/ola284vo_2026-07-11%2016_53_28-Epic%20Pen%20Content%20Surface_%20__._DISPLAY1.png",
  proofTraffic: "https://customer-assets.emergentagent.com/job_expertise-to-leads/artifacts/pfyg83jq_2026-07-11%2016_50_35-Epic%20Pen%20Content%20Surface_%20__._DISPLAY1.png",
  proofLeads: "https://customer-assets.emergentagent.com/job_expertise-to-leads/artifacts/sjkhca3i_2026-07-11%2016_54_05-Epic%20Pen%20Content%20Surface_%20__._DISPLAY1.png",
  t1: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=70",
  t2: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=70",
  t3: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=400&q=70",
};

export const TESTIMONIAL_VIDEO = {
  id: "KRCLcFRYPCQ",
  watch: "https://youtu.be/KRCLcFRYPCQ",
  embed: "https://www.youtube.com/embed/KRCLcFRYPCQ?autoplay=1",
  thumb: "https://img.youtube.com/vi/KRCLcFRYPCQ/maxresdefault.jpg",
};

export const NAV_LINKS = [
  { label: "Why YouTube", id: "why-youtube" },
  { label: "The System", id: "system" },
  { label: "Curriculum", id: "curriculum" },
  { label: "Support", id: "support" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
];

export const SNAPSHOT = [
  { big: "12", unit: "Months", desc: "Course access, mentorship, and community support" },
  { big: "20+", unit: "Lessons", desc: "Step-by-step recorded training lessons" },
  { big: "24", unit: "Calls", desc: "Live implementation sessions during the year" },
  { big: "300+", unit: "Formulas", desc: "Psychology-based title formulas" },
  { big: "1:1", unit: "Audit", desc: "Personal YouTube channel feedback" },
  { big: "30", unit: "Days", desc: "Money-back guarantee" },
];

export const PROBLEMS = [
  { n: "01", t: "No Topic Clarity", d: "You are always confused about what video to create next." },
  { n: "02", t: "Weak Titles", d: "You create useful videos, but your titles do not attract the right viewers or give them a reason to click." },
  { n: "03", t: "Confusing Thumbnails", d: "Your thumbnails do not clearly communicate what the video offers or why someone should watch." },
  { n: "04", t: "Random Content", d: "Every upload follows a different direction, so your channel struggles to build authority." },
  { n: "05", t: "Wrong Subscribers", d: "You may get views and subscribers, but many of them are not genuinely interested in your offers." },
  { n: "06", t: "No Lead System", d: "People watch your videos, but there is no clear path to WhatsApp, your landing page, community, consultation, or offer." },
];

export const VIDEO_JOBS = [
  { n: "01", t: "Get Discovered", d: "Create videos around questions and problems your ideal customers are already searching for.", job: "Bring the right viewer into your world.", color: "#0B31EB" },
  { n: "02", t: "Educate the Viewer", d: "Answer important questions and help viewers understand their problem, options, and possible solution.", job: "Turn curiosity into serious interest.", color: "#4CAF48" },
  { n: "03", t: "Build Trust", d: "Demonstrate your knowledge, teaching style, experience, and ability to solve meaningful problems.", job: "Make your expertise believable.", color: "#FFCB52" },
  { n: "04", t: "Create the Next Step", d: "Guide interested viewers toward WhatsApp, your landing page, community, consultation, course, or relevant offer.", job: "Turn attention into action.", color: "#E90019" },
];

export const WHY_YT = [
  { t: "Searchable for Years", d: "A useful video can continue appearing when people search for the problem it solves—even months or years after publication." },
  { t: "Built for Long-Form Trust", d: "Your audience can spend 10, 20, or 60 minutes learning from you before they ever contact you." },
  { t: "Multiple Discovery Paths", d: "Your videos can be discovered through YouTube Search, Browse Features, and Suggested Videos." },
  { t: "Viewers Arrive With Intent", d: "Many viewers are actively looking for answers, comparisons, tools, services, or solutions." },
  { t: "Your Content Becomes an Asset", d: "Paid traffic stops when the budget stops. Strategic YouTube videos can continue bringing attention and inquiries over time." },
  { t: "Clear Path to Conversion", d: "Guide viewers toward WhatsApp, a landing page, consultation, community, course, service, or relevant affiliate product." },
];

export const ROADMAP = [
  { n: "1", t: "Position", d: "Clarify your niche, audience, expertise, offer, and monetization direction." },
  { n: "2", t: "Research", d: "Understand demand, questions, competition, pain points, intent, and content gaps." },
  { n: "3", t: "Create", d: "Turn research into content clusters, titles, scripts, calendars, and practical videos." },
  { n: "4", t: "Discover", d: "Build content for Search, Browse, and Suggested Video opportunities." },
  { n: "5", t: "Build Trust", d: "Create useful content that demonstrates expertise and solves meaningful problems." },
  { n: "6", t: "Capture", d: "Move interested viewers toward WhatsApp, a community, lead magnet, or landing page." },
  { n: "7", t: "Convert", d: "Connect attention with courses, consulting, services, digital products, PDFs, or affiliate offers." },
];

export const PROOF = [
  { t: "Course & Platform Earnings", img: "proofEarnings", cap: "₹5,69,981 in total earnings on a teaching platform—driven by high-intent viewers, not vanity metrics.", rot: -3, fit: "contain" },
  { t: "Ranking on YouTube Search", img: "proofRanking", cap: "\u201CBest whiteboard for online teaching\u201D—38K+ views, ranking for a real, high-intent search query.", rot: 2, fit: "cover" },
  { t: "Evergreen Discovery", img: "proofTraffic", cap: "61.1% of views come from YouTube Search—organic, evergreen traffic that keeps working over time.", rot: -2, fit: "contain" },
  { t: "Affiliate Commissions", img: "proofAffiliate", cap: "$5,398.43 paid out and 57 signups from aligned affiliate recommendations tied to expertise.", rot: 3, fit: "contain" },
  { t: "Real Lead Flow", img: "proofLeads", cap: "\u201CHi Ratish Ji, I need your help\u201D—a steady flow of relevant viewers reaching out on WhatsApp.", rot: -2, fit: "cover" },
];

export const TRANSFORM = {
  before: [
    "Unclear niche and positioning",
    "Confused about what to post",
    "Unsure how to write scripts",
    "Random videos",
    "Few inquiries",
    "Dependence on referrals",
    "Dependence on paid traffic",
    "Lack of consistency",
    "No accountability",
  ],
  after: [
    "Clear niche positioning",
    "Research-backed content strategy",
    "Strategic content clusters",
    "Practical content calendar",
    "Repeatable scripting process",
    "Efficient recording workflow",
    "Understanding Search, Browse & Suggested traffic",
    "Viewer-to-lead pathway",
    "Evergreen content library",
    "Support and accountability",
  ],
};

export const CURRICULUM = [
  { n: "01", t: "Foundation & Positioning", d: "Define your niche, audience, and offer so every video points in one clear direction. Set the base for a channel built as a business asset." },
  { n: "02", t: "Research & Customer Psychology", d: "Learn how your ideal customer searches, thinks, and decides. Find high-intent topics, pain points, and content gaps worth creating for." },
  { n: "03", t: "Channel & Content Strategy", d: "Turn research into content clusters and a channel structure that builds authority instead of scattered, random uploads." },
  { n: "04", t: "Practical Content Creation", d: "A repeatable process for scripting, recording, and producing useful videos—without heavy cinematic editing." },
  { n: "05", t: "YouTube Traffic & Packaging", d: "Titles, thumbnails, and packaging designed for Search, Browse, and Suggested traffic so the right people click." },
  { n: "06", t: "Internal Promotion", d: "Connect your videos to each other to keep viewers watching, learning, and moving deeper into your world." },
  { n: "07", t: "Lead Generation", d: "Build clear pathways from video to WhatsApp, community, lead magnet, or landing page." },
  { n: "08", t: "Conversion & Monetization", d: "Connect attention to courses, consulting, services, digital products, PDFs, and aligned affiliate offers." },
];

export const TOOLKIT = [
  "Proven Title & Thumbnail Formula Vault",
  "300+ Psychology-Based Title Library",
  "Content Calendar System",
  "AI Prompt Library",
  "YouTube Scriptwriting Toolkit",
  "Lead Magnet Templates",
  "Funnel Strategy",
  "Landing Page Templates",
  "Website Templates",
  "YouTube Case Studies",
  "OBS Setup Guide",
  "AI Image and Animation Guide",
];

export const SUPPORT = [
  { big: "20+", t: "Recorded Lessons" },
  { big: "2×", t: "Live Calls Every Month" },
  { big: "12", t: "Months Program Access" },
  { big: "90", t: "Minutes Approx. Call Duration" },
  { big: "✓", t: "Call Recordings Included" },
  { big: "1:1", t: "Audit & Feedback" },
  { big: "1yr", t: "Private Community" },
  { big: "★", t: "Certificate After Completion" },
];

export const TESTIMONIALS = [
  { name: "Priya Menon", role: "Nutrition Coach", before: "Posting random recipe videos with no clarity.", clear: "Understood how to target high-intent searches.", result: "Now gets consultation inquiries through WhatsApp weekly.", img: "t1", size: "tall" },
  { name: "Arjun Nair", role: "Finance Educator", before: "Chasing subscribers, not customers.", clear: "Learned the viewer-to-lead pathway.", result: "Sells his course to the right audience organically.", img: "t2", size: "wide" },
  { name: "Sana Kapoor", role: "Career Consultant", before: "No topic strategy, inconsistent uploads.", clear: "Built research-backed content clusters.", result: "Evergreen videos bring steady inquiries.", img: "t3", size: "normal" },
];

export const WHO_FOR = {
  yes: [
    "You are a coach, consultant, teacher, trainer, freelancer, or expert",
    "You want to monetize your expertise",
    "You want high-intent viewers",
    "You believe in original useful content",
    "You want sustainable growth",
    "You are willing to research and publish consistently",
    "You are ready to implement",
    "You want authority rather than random popularity",
  ],
  no: [
    "You want overnight success",
    "You want only viral hacks",
    "You want to repost copyrighted content",
    "You depend on trends and controversy",
    "Your main goal is only AdSense",
    "You expect results without implementation",
    "You care only about random views",
    "You want heavily edited entertainment-style content",
  ],
};

export const OBJECTIONS = [
  { q: "I am starting from zero", a: "Perfect. You will build on a clear strategy from day one instead of unlearning random habits later." },
  { q: "My niche is too competitive", a: "Competition signals demand. We focus on specific, high-intent topics where the right viewer can still find you." },
  { q: "I am not a good speaker", a: "This is not about performance. Clear, useful teaching builds more trust than polished entertainment." },
  { q: "I am camera shy", a: "You improve with reps and a repeatable process. Many students start nervous and grow into it." },
  { q: "I do not know editing", a: "The program avoids heavy cinematic editing. Simple, clear videos work for lead generation." },
  { q: "I have a full-time job", a: "The system is built around research and batching so you can create efficiently around a schedule." },
  { q: "I do not have enough time", a: "You do not need daily uploads. You need the right videos, published consistently over time." },
  { q: "I am too old to start", a: "Experience and expertise are advantages on YouTube. Authority is built on knowledge, not age." },
  { q: "Can I make videos in Hindi?", a: "Yes. Teaching is in a Hindi–English (Hinglish) mix, and you can create in the language your audience prefers." },
  { q: "I already have a channel", a: "Great. We can realign your existing channel around strategy, positioning, and lead generation." },
  { q: "How quickly will I see results?", a: "Results vary by niche, consistency, and implementation. This is a build-something-valuable program, not overnight." },
  { q: "Will this work for my niche?", a: "If your audience searches for problems you can solve, YouTube can work. We validate this during research." },
];

export const OFFER_INCLUDES = [
  "Complete recorded training",
  "Two monthly live calls",
  "Call recordings",
  "Community access",
  "Audit and feedback opportunities",
  "Templates and resources",
  "Bonuses",
  "Updates during active access",
  "12-month implementation support",
];

export const FAQ = [
  { q: "Is there a money-back guarantee?", a: "Yes. You have 30 days to experience the training and decide. Eligible approved refund requests within the period are processed per the published refund terms." },
  { q: "How long will I have access?", a: "12 months of program access, including recorded lessons, live calls, community, and resources." },
  { q: "Are there any required upsells?", a: "No. Everything described in the offer is included. There are no mandatory upsells." },
  { q: "What equipment will I need?", a: "A basic camera or smartphone and a decent microphone are enough to start." },
  { q: "Do I need expensive equipment?", a: "No. The program focuses on strategy and useful content, not expensive gear." },
  { q: "Will I need paid software?", a: "No paid software is required. We cover free tools like OBS and simple workflows." },
  { q: "Will live calls be recorded?", a: "Yes. Call recordings are included so you can catch up if you miss a session." },
  { q: "Is EMI available?", a: "Please reach out on WhatsApp to discuss available payment options." },
  { q: "Do I have to upload every day?", a: "No. Consistency matters more than frequency. Strategic videos over time beat daily random uploads." },
  { q: "Can a complete beginner join?", a: "Yes. The curriculum starts from foundation and positioning, ideal for beginners willing to implement." },
  { q: "What if I already have a channel?", a: "You can realign your existing channel around strategy, positioning, and lead generation." },
  { q: "What is the teaching language?", a: "Teaching is in a Hindi–English (Hinglish) mix for clarity." },
  { q: "Will this work for my niche?", a: "If your audience searches for problems you can solve, YouTube can work. We validate this during research." },
  { q: "How quickly will I see results?", a: "Results vary based on niche, expertise, offer, consistency, and implementation. No outcome is guaranteed." },
];

export const FINAL_LIST = [
  "A clear niche",
  "A research system",
  "A strategic content calendar",
  "A library of useful videos",
  "Stronger authority",
  "Searchable expertise",
  "A viewer-to-lead pathway",
  "A system you understand and can improve",
];
